module.exports = __webpack_public_path__ + "img/jiax2.cdc61c95.png";